import { render, staticRenderFns } from "./ManagementGroupStudents.vue?vue&type=template&id=6bb07bc0&scoped=true"
import script from "./ManagementGroupStudents.vue?vue&type=script&lang=js"
export * from "./ManagementGroupStudents.vue?vue&type=script&lang=js"
import style0 from "./ManagementGroupStudents.vue?vue&type=style&index=0&id=6bb07bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb07bc0",
  null
  
)

export default component.exports